import React, { useState } from 'react'
import AddDataSource from './AddDataSource'

function DataSourceDropDown({ sources, setConductReload }) {

    const [showAddModal, setShowAddModal] = useState(false);
    const [source, setSource] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const handleAddClick = (source) => { 
        setShowAddModal(true);
        setSource(source);
        setIsDropdownOpen(false);
    }

    return (
        <>
            <div className="max-w-7xl mx-auto pb-3">
                <div className="flex justify-center">
                    <div className="relative inline-block">
                        <button 
                            className="px-6 py-3 text-lg bg-gray-600 hover:bg-gray-700 text-white rounded-lg transition-colors flex items-center gap-2"
                            type="button" 
                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        >
                            Connect Your Data Source
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>
                        {isDropdownOpen && (
                            <div className="absolute left-0 mt-2 w-64 bg-white dark:bg-slate-800 rounded-lg shadow-lg border border-gray-200 dark:border-slate-700 z-50">
                                {sources.map((source) => (
                                    <button
                                        key={source.id}
                                        className="w-full px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors flex items-center gap-3 first:rounded-t-lg last:rounded-b-lg"
                                        onClick={() => handleAddClick(source)}
                                    >
                                        <img src={`${source.icon_url}`} height="25px" className="inline-block align-middle" alt={source.label} />
                                        <span className="text-gray-900 dark:text-white">{source.label}</span>
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {showAddModal && <AddDataSource
                source={source}
                showAddModal={showAddModal}
                setShowAddModal={setShowAddModal}
                setConductReload={setConductReload}
            />}

        </>
    )
}

export default DataSourceDropDown
